import { buildFullName } from 'src/lib/formatters'

/**
 * Build a display name for an Employee row in the Performance tab cards.
 *
 * Wraps the shared `buildFullName` formatter and adds a stable fallback
 * when both name parts are missing (so the table never shows "—" or empty
 * strings — every row gets a recognizable handle). Used by both the
 * Employee Leaderboard and Employee Funnels containers.
 */
export const buildEmployeeDisplayName = (
  firstName: string | null,
  lastName: string | null,
  fallbackId: string
): string => {
  const fullName = buildFullName({ firstName, lastName })
  if (fullName) return fullName
  return `Employee ${fallbackId.slice(0, 6)}`
}
